module.exports = __webpack_public_path__ + "plugins/web/img/bg.837e99ea.png";